import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DrawerOutlet } from '@/shared/ui/drawer/drawer-outlet';
import { ModalOutlet } from '@/shared/ui/modal/modal-outlet';

@Component({
  selector: 'dialab-root',
  imports: [RouterOutlet, ModalOutlet, DrawerOutlet],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
